module.exports = __webpack_public_path__ + "static/media/axiomaProduct.685db3d2.jpeg";